import { Link } from 'react-router-dom';
import Button from './Button';

const ButtonLink = Button.withComponent(Link);

export default ButtonLink;
